import { CbTemplateRawSchema } from '@app/schemas/cbTemplateRawSchema';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// Techdebt: replace it's use in react components with @app/store corresponding file

const initialState: CbTemplateRawSchema = {
  id: 0,
  templateName: '',
  content: '',
  templateCategory: 'Online',
  dynamicVariables: [],
};

const cbSelectedTemplateSlice = createSlice({
  name: 'cbSelectedTemplate',
  initialState,
  reducers: {
    updateCbSelectedTemplate(state, action: PayloadAction<Partial<CbTemplateRawSchema>>) {
      const { payload } = action;

      const parsedPayload: Partial<CbTemplateRawSchema> = {
        id: payload.id ?? state.id,
        templateName: payload.templateName ?? state.templateName,
        content: payload.content ?? state.content,
        templateCategory: payload.templateCategory ?? state.templateCategory,
        dynamicVariables: payload.dynamicVariables ?? state.dynamicVariables,
      };

      return { ...state, ...parsedPayload };
    },
    resetCbSelectedTemplate() {
      return initialState;
    },
  },
});

export const { updateCbSelectedTemplate, resetCbSelectedTemplate } = cbSelectedTemplateSlice.actions;

export default cbSelectedTemplateSlice.reducer;
